import { render, staticRenderFns } from "./firmList.vue?vue&type=template&id=31785f7a&scoped=true&"
import script from "./firmList.vue?vue&type=script&lang=js&"
export * from "./firmList.vue?vue&type=script&lang=js&"
import style0 from "./firmList.vue?vue&type=style&index=0&id=31785f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31785f7a",
  null
  
)

export default component.exports